// extracted by mini-css-extract-plugin
export default {"navigation":"LandingPage_navigation__X-Rjn"};